import axios from 'axios';

const server = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  timeout: 1000,
  headers: { 'X-Custom-Header': 'foobar' }
});
export const BASE_URL = `${process.env.REACT_APP_API_URL}`
export default server;
